<template>
  <v-dialog
    persistent
    max-width="370"
    v-model="dialog"
    overlay-color="green"
    overlay-opacity="1"
  >
    <v-card>
      <v-card-subtitle class="pt-5 mb-0 orange darken-2 white--text">
        <div class="mb-2">
          <v-img
            contain
            width="60"
            src="/favicon.png"
            class="shrink mx-auto"
            transition="scale-transition"
          />
        </div>
        <h3 class="text-center">{{ title }} Election</h3>
        <hr class="my-4" />
        <v-btn to="/" small depressed>
          <v-icon left>mdi-arrow-left-bold</v-icon> Back to Live Elections
        </v-btn>
      </v-card-subtitle>
      <v-card-title class="text-h5 mt-2 mb-0">
        {{ retrieve ? "Retrieve PIN" : "Voter Login" }} <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text>
        <p>
          Please click the <b>Get Voting PIN</b> button to receive your evoting
          PIN.
        </p>
        <v-form
          class="mt-5"
          v-model="authFormValid"
          :disabled="authenticating"
          @submit.prevent="authenticateVoter"
        >
          <v-text-field
            v-model="email"
            prepend-inner-icon="mdi-email"
            :rules="rules.required"
            clearable
            outlined
            placeholder="Email"
            label="Email"
          ></v-text-field>
          <v-text-field
            v-model="pin"
            prepend-inner-icon="mdi-lock-question"
            :rules="rules.required"
            clearable
            outlined
            label="eVoting PIN"
          ></v-text-field>

          <v-row class="mt-2 pa-3">
            <v-btn
              type="submit"
              class="white--text mb-1 mr-1"
              color="green darken-1"
              :disabled="authenticating || !authFormValid"
              :loading="authenticating"
            >
              Login and cast
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary darken-1"
              class="mb-1 mr-1"
              :to="`/retrieve/${uuid}`"
            >
              Get Voting PIN
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, phone, email } from "../../tools/rules";
export default {
  props: {
    uuid: {
      type: String,
    },
    title: {
      type: String,
    },
    session: {
      type: String,
      default: '2021/2022'
    },
  },

  data: () => ({
    authFormValid: false,
    authenticating: false,
    rules: {
      required,
      phone,
      email,
    },
    dialog: true,
    email: null,
    pin: null,
    retrievedPIN: null,

    retrieve: false,
    retrieved: false,
    retrieving: false,
    retrieveFormValid: false,
  }),

  methods: {
    authenticateVoter() {
      this.authenticating = true;

      const data = {
        pin: this.pin,
        email: this.email,
      };

      this.$axios({
        url: `/authenticate-pg/${this.uuid}`,
        method: "POST",
        data,
      })
        .then(({ data: { voter, sid } }) => {
          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Login successful",
          });
          this.$emit("success", data, voter, sid);
          this.dialog = false;
        })
        .catch((error) => {
          const { message } = error.response.data;
          this.$bus.$emit("snackbar", {
            type: "error",
            message: message || "Login failed",
          });
        })
        .finally(() => {
          this.authenticating = false;
        });
    },
    retrievePIN() {
      this.retrieving = true;

      const data = {
        dob: this.dob,
        registration: this.registration,
        email: this.email,
        phone: this.phone,
        sponsor_phone: this.sponsor_phone,
        rrr: String(this.rrr).toUpperCase(),
      };

      this.$axios({
        url: `/retrieve-pin/${this.uuid}`,
        method: "POST",
        data,
      })
        .then(({ data: { pin } }) => {
          this.pin = pin;
          this.retrievedPIN = pin;

          this.retrieve = false;
          this.authFormValid = true;

          // this.retrieved = true;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve PIN",
          });
        })
        .finally(() => {
          this.retrieving = false;
        });
    },
  },
};
</script>
